import { RootState } from "@/store/store";
import { GUID } from "@faro-lotv/foundation";

/**
 * @param state  Current state
 * @returns ID of element to be aligned in current session of Alignment Wizard
 */
export function selectWizardElementToAlignId(
  state: RootState,
): GUID | undefined {
  return state.alignmentWizardMode.elementToAlignId;
}

/**
 * @param state  Current state
 * @returns ID of element to be recommended to the user in the Alignment Wizard
 */
export function selectWizardRecommendedElementId(
  state: RootState,
): GUID | undefined {
  return state.alignmentWizardMode.recommendedElementId;
}

/**
 * @param state  Current state
 * @returns ID of the point cloud stream used for alignment when the element to align contains multiple streams
 */
export function selectWizardPointCloudStreamToAlignId(
  state: RootState,
): GUID | undefined {
  return state.alignmentWizardMode.pointCloudStreamToAlignId;
}

/**
 * @param state  Current state
 * @returns ID of element to be used as a reference in current session of Alignment Wizard
 */
export function selectWizardReferenceElementId(
  state: RootState,
): GUID | undefined {
  return state.alignmentWizardMode.referenceElementId;
}

/**
 * @param state  Current state
 * @returns ID of the point cloud stream used for alignment when the reference element contains multiple streams
 */
export function selectWizardReferencePointCloudStreamId(
  state: RootState,
): GUID | undefined {
  return state.alignmentWizardMode.referencePointCloudStreamId;
}

/**
 * @param state  Current state
 * @returns true if ControlPoint alignment mode for sheet or area selected
 */
export function selectIsControlPointSheetAlignment(state: RootState): boolean {
  return state.alignmentWizardMode.isControlPointsAlignment;
}
